<template>
	<Alert type="success">
		<template #icon>
			<IconCheck size="lg" />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconCheck from '../icon/IconCheck.vue'
import AlertMixin from './AlertMixin.js'
export default {
	mixins: [AlertMixin],
	components: {
		Alert,
		IconCheck
	}
}
</script>
